<template>
  <div>
    <div class="human-data__block human-data__retreat">
      <div class="a-input-group a-input-group--human-data">
        <p class="a-label" v-t="'labels.email'">:</p>
        <div class="a-form-field">
          <div class="a-input-group">
            <div class="a-input-group__prepend ">@</div>
            <input type="email" class="a-input" placeholder="Email" v-model.trim="email">
          </div>
          <span class="a-helper-text a-validation-error" v-if="$v.email.$dirty && !$v.email.required">{{$t('labels.mandatory-field')}}</span>
          <span class="a-helper-text a-validation-error" v-else-if="$v.email.$dirty && !$v.email.email">{{$t('validation-error.invalid-format')}}</span>
        </div>
      </div>
    </div>
    <div class="human-data__block human-data__retreat">
      <div class="a-input-group a-input-group--human-data">
        <p class="a-label" v-t="'labels.phone-short'">:</p>
        <div class="a-form-field">
          <div class="a-input-group">
            <div class="a-input-group__prepend ">+</div>
            <input type="email" class="a-input" placeholder="Телефон" v-model.trim="phone">
          </div>
          <span class="a-helper-text a-validation-error" v-if="$v.phone.$dirty && !$v.phone.required">{{$t('labels.mandatory-field')}}</span>
          <span class="a-helper-text a-validation-error" v-else-if="$v.phone.$dirty && !$v.phone.phone">{{$t('validation-error.invalid-format')}}</span>
        </div>
      </div>
    </div>
    <div class="human-data__block">
      <button class="gui-btn gui-btn--red gui-btn--w-184"
              @click.prevent="onPasswordChangeClick"
              v-t="'buttons.change-password'">
      </button>
      <change-password-dialog ref="password"></change-password-dialog>
    </div>
    <div class="human-data__block">
      <div class="a-label human-data__fio-label" v-t="'labels.username'">:</div>
      <div class="a-form-field">
        <input type="text" class="a-input" :placeholder="$t('labels.lastname')" v-model.trim="lastName">
        <span class="a-helper-text a-validation-error" v-if="$v.lastName.$dirty && !$v.lastName.required">{{$t('labels.mandatory-field')}}</span>
      </div>

      <div class="a-form-field">
        <input type="text" class="a-input" :placeholder="$t('labels.firstname')" v-model.trim="firstName">
        <span class="a-helper-text a-validation-error" v-if="$v.firstName.$dirty && !$v.firstName.required">{{$t('labels.mandatory-field')}}</span>
      </div>

      <div class="a-form-field">
        <input type="text" class="a-input" :placeholder="$t('labels.middlename')" v-model.trim="middleName">
      </div>
    </div>
    <div class="human-data__block">
      <div class="a-label " v-t="'labels.passport-series-and-number'">:</div>
      <div class="a-form-field">
        <input type="text" minlength="2" maxlength="4" class="a-input a-input--mini-mini" :placeholder="$t('labels.passport-series')" v-model.trim="passportSeries">
        <span class="a-helper-text a-validation-error" v-if="$v.passportSeries.$dirty && !$v.passportSeries.required">{{$t('labels.mandatory-field')}}</span>
      </div>

      <div class="a-form-field">
        <input type="text" minlength="6" maxlength="7" class="a-input a-input--mini-mini" :placeholder="$t('labels.passport-number')" v-model.trim="passportId">
        <span class="a-helper-text a-validation-error" v-if="$v.passportId.$dirty && !$v.passportId.required">{{$t('labels.mandatory-field')}}</span>
      </div>
    </div>
    <div class="human-data__block human-data__block--rows" v-if="!permissions.CANNOT_SET_CATEGORIES">
      <div class="a-label " v-t="'labels.categories'">:</div>
      <div class="a-form-field" style="width:100%">
        <categories-search :placeholder="$t('labels.categories')"
                           multiple
                           v-model="categories">
        </categories-search>
        <span class="a-helper-text a-validation-error" v-if="$v.categories.$dirty && !$v.categories.required">{{$t('labels.mandatory-field')}}</span>
      </div>
    </div>
    <div class="human-data__block" v-if="permissions.CAN_SET_DEPARTMENT">
      <div class="a-label " v-t="'labels.department'">:</div>
      <div class="a-form-field"  style="width:100%">
        <department-search :placeholder="$t('labels.department')"
                           v-model="department">
        </department-search>
        <span class="a-helper-text a-validation-error" v-if="$v.department.$dirty && !$v.department.required">{{$t('labels.mandatory-field')}}</span>
      </div>
    </div>
    <div class="personal-data__btn-block">
      <button class="gui-btn gui-btn--red gui-btn--w-140" @click.prevent="onSaveClick" v-t="'buttons.save'"></button>
      <button class="gui-btn gui-btn--white-border gui-btn--w-140" @click.prevent="$emit('close')" v-t="'buttons.cancel'"></button>
    </div>
    <loading v-if="loading"></loading>
  </div>
</template>

<script>
  import { required, requiredIf, email, passportSeries, passportID, phone, minLength } from '@/validators'
  import Errors from '@/api/types/errors'
  import ChangePasswordDialog from './ChangePasswordDialog'
  import DepartmentSearch from '@/components/common/inputs/DepartmentSearch'
  import CategoriesSearch from '@/components/common/inputs/CategoriesSearch'

  export default {
    components: {
      CategoriesSearch,
      ChangePasswordDialog,
      DepartmentSearch,
      CategoriesSearch
    },

    data: () => ({
      id: undefined,
      email: undefined,
      phone: undefined,
      firstName: undefined,
      lastName: undefined,
      middleName: undefined,
      passportId: undefined,
      passportSeries: undefined,
      department: undefined,
      categories: []
    }),

    validations: {
      email: { required, email },
      phone: { required, phone },
      firstName: { required },
      lastName: { required },
      passportSeries: {
        required
      },
      passportId: {
        required
      },
      categories: {
        required: requiredIf(function() {
          return !this.permissions.CANNOT_SET_CATEGORIES;
        })
      },
      department: {
        required: requiredIf(function() {
          return this.permissions.CAN_SET_DEPARTMENT;
        })
      }
    },

    computed: {
      permissions() { return this.$store.getters.currentUser.permissions },
    },

    created() {
      const user = this.$store.getters.currentUser;

      if (user) {
        Object.assign(this.$data, {
          id: user.id,
          email: user.email.unverified || user.email.verified,
          phone: user.phone.unverified || user.phone.verified,
          firstName: user.firstName,
          lastName: user.lastName,
          middleName: user.middleName,
          passportId: user.passport.id,
          passportSeries: user.passport.series,
          categories: user.categories || [],
          department: user.department
        });
      }
    },

    methods: {
      onPasswordChangeClick() {
        this.$refs.password.open();
      },

      async onResendEmailConfirmationClick() {
        try {
          await this.$store.dispatch('resendEmailConfirmation')
        }
        catch(e) {
          console.error('unable to resend email confirmation', e);
          this.globalErrorHandler(e);
        }
      },

      async onSaveClick() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        this.runAction(async () => {
          try {
            const data = {
              id: this.$store.getters.currentUser.id,
              email: this.email,
              phone: this.phone,
              firstName: this.firstName,
              lastName: this.lastName,
              middleName: this.middleName,
              passportId: this.passportId,
              passportSeries: this.passportSeries,
              categories: this.categories.map(e => e.id),
              department: this.department ? this.department.id : undefined
            };

            await this.$store.dispatch('modifyAccount', data);

            this.$emit('close');
          }
          catch(e) {
            console.error('unable to modify user profile', e);
            this.globalErrorHandler(e);
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
